
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resetPassword",
      function () {
        return require("private-next-pages/resetPassword/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resetPassword"])
      });
    }
  